class SocialLogin implements IDigitalIdentityHubModule {
  // Actually these providers are already specified somewhere in janrain settings
  public name = "SocialLogin";

  private inited = false;
  private currentView = "changeEmail";
  private isOpen = false;

  private authProfileFirstName: string;
  private authProfileLastName: string;
  private authProfileEmail: string;
  private buttonClick: boolean;
  private provider: string;
  private signInField: string;
  private signInFieldSet: boolean;

  public init() { /* No functionality */ }

  public ready() {
    janrain.events.onCaptureSaveSuccess.addHandler(result => {
      if (result.action === "socialSignin") {
        if (result.authProvider !== "doccheck"
         && result.authProvider !== "kakao"
         && result.authProvider !== "naver"
         && result.authProvider !== "gouv") {
          this.authProfileFirstName = result.authProfileData.name.givenName;
          this.authProfileLastName = result.authProfileData.name.familyName;
        }
        this.authProfileEmail = result.authProfileData.verifiedEmail;
        this.provider = result.authProvider;
      }
    });
    janrain.events.onCaptureRenderComplete.addHandler(result => {
      // Hides email field and fill referral field
      if (result.screen === "socialRegistration") {
        const emailField = document.getElementById("capture_socialRegistration_email") as HTMLInputElement;
        localStorage.setItem("socialEmail", emailField.value);
        localStorage.setItem("noEmailChange", "true");
        this.initSocialLoginForm();
        this.initPopup();
        if (!this.signInFieldSet) {
          this.setUpSignInField();
        }
      }

      if (result.screen === "editProfile") {
        if (document.getElementsByClassName("janrain-provider-text-linkedin-oauth2")[0]) {
          document.getElementsByClassName("janrain-provider-text-linkedin-oauth2")[0].innerHTML = "LinkedIn";
        }
      }
      if (result.screen === "traditionalRegistration") {
        localStorage.setItem("noEmailChange", "true");
      }
    });

    janrain.events.onCaptureValidationFailed.addHandler(result => {
      if (result.field.id === "capture_socialRegistration_preregEmailAddress" && result.message === "pre-registered") {
        this.testPrereg();
      }

      // reset button click if validation was any other type than unique
      if (result.field.id === "capture_socialRegistration_preregEmailAddress" && result.message !== "pre-registered") {
        this.resetButtonClick();
      }

      // if unique validation fails on email address check hide default form and display sign in form
      if (result.field.id === "capture_socialRegistration_emailAddress" &&
      (result.message === "email-used" || result.message === "Email address exists." || result.message === "Email này đã tồn tại." || result.message === "이미 가입된 아이디(이메일)입니다.")) {
        this.setViewSignIn();
      }
    });

    janrain.events.onCaptureValidationSuccess.addHandler(result => {
      // remove classes to preserve default look
      if (result.field.id === "capture_socialRegistration_preregEmailAddress") {
        const preregField = document.getElementById("capture_socialRegistration_form_item_preregEmailAddress");
        preregField.classList.remove("capture_validated");
        preregField.classList.remove("capture_validating");
      }
      // user isn't prereg => hide field and unhide emailAddress field, copy value, trigger validation
      if (result.field.id === "capture_socialRegistration_preregEmailAddress" && this.buttonClick) {
        window.DigitalIdentityHub.utilities.getCaptureFormItem("socialRegistration", "preregEmailAddress")!.style.display = "none";
        window.DigitalIdentityHub.utilities.getCaptureFormItem("socialRegistration", "emailAddress")!.style.display = "block";
        window.DigitalIdentityHub.utilities.getCaptureField("socialRegistration", "emailAddress")!.value = result.field.value;
        window.DigitalIdentityHub.utilities.getCaptureField("socialRegistration", "emailAddress")!.focus();
        window.DigitalIdentityHub.utilities.getCaptureField("socialRegistration", "emailAddress")!.blur();
      }

      // user doesn't exist => store email
      if (result.field.id === "capture_socialRegistration_emailAddress" && this.buttonClick) {
        this.isUniqueEmail();
      }
    });
  }

  private initSocialLoginForm = () => {
    // init social login form
    const changeEmailLink = document.getElementById("changeEmailLink");
    if (changeEmailLink) {
      changeEmailLink.addEventListener("click", this.showModal);

      const userEmailReadOnly = document.getElementById("userEmailReadOnly") as HTMLSpanElement;
      if (userEmailReadOnly) {
        userEmailReadOnly.innerText = this.authProfileEmail;
      }

      if (this.authProfileFirstName) {
        (document.getElementById("capture_socialRegistration_firstName") as HTMLInputElement).value = this.authProfileFirstName;
      }
      if (this.authProfileLastName) {
        (document.getElementById("capture_socialRegistration_lastName") as HTMLInputElement).value = this.authProfileLastName;
      }

      const capture_socialRegistration_form_item_email = document.getElementById("capture_socialRegistration_form_item_email");
      capture_socialRegistration_form_item_email.style.display = "none";

      document.getElementById("capture_socialRegistration_firstName").addEventListener("input", this.storeFirstName);
      document.getElementById("capture_socialRegistration_lastName").addEventListener("input", this.storeLastName);
    }
    // set up "social" parameter for referral tracking
    const param = window.DigitalIdentityHub.utilities.getParameterByName("social");
    const socialProvider = this.provider;
    if (param !== socialProvider) {
      const separator = window.location.href.indexOf("?") === -1 ? "?" : "&";
      const newURL = window.top.location.href + separator + "social=" + socialProvider;
      window.history.pushState({ path: newURL }, "", newURL);
    }
  };

  private initPopup = () => {
    this.initEmailChangePopup();
    this.enableModalCloseButton();
    this.buttonClick = false;

    this.inited = true;

    // show modal if user not sharing FB email and hide close button
    if ((document.getElementById("capture_socialRegistration_email") as HTMLInputElement).value === "") {
      this.disableModalCloseButton();
      this.showModal();
    }

    if (this.isOpen) {
      if (this.authProfileFirstName) {
        (document.getElementById("capture_socialRegistration_firstName") as HTMLInputElement).value = this.authProfileFirstName;
      }
      if (this.authProfileLastName) {
        (document.getElementById("capture_socialRegistration_lastName") as HTMLInputElement).value = this.authProfileLastName;
      }
      if (this.authProfileEmail) {
        const emailAddressReadOnly = document.getElementById("capture_socialRegistration_emailAddress_readonly") as HTMLInputElement;
        const userEmailReadOnly = document.getElementById("userEmailReadOnly") as HTMLSpanElement;
        if (emailAddressReadOnly) {
          emailAddressReadOnly.innerHTML = this.authProfileEmail;
        }
        if (userEmailReadOnly) {
          userEmailReadOnly.innerHTML = this.authProfileEmail;
        }
        (document.getElementById("capture_socialRegistration_email") as HTMLInputElement).value = this.authProfileEmail;
      }

      this.showModal();

      if (this.currentView === "changeEmail") {
        this.setViewChangeEmail();
      } else if (this.currentView === "signIn") {
        this.setViewSignIn();
      }
    }
  };

  private storeFirstName = e => {
    this.authProfileFirstName = e.target.value;
  };

  private storeLastName = e => {
    this.authProfileLastName = e.target.value;
  };

  // Part of the pre-registration flow
  private showCreatePassword = () => {
    janrain.capture.ui.postCaptureForm("createPasswordForm", {
      preregEmailAddress: (document.getElementById("capture_socialRegistration_preregEmailAddress") as HTMLInputElement).value
    });
  };

  private hideModal = () => {
    this.isOpen = false;
    const popup = document.getElementById("changeEmailModal");
    popup.style.display = "none";

    try {
      document.getElementById("checkEmailForm_form").style.display = "block";
      document.getElementById("changeEmailConfirm").style.display = "block";
      document.getElementById("changeEmailClose").style.display = "block";
      document.getElementById("signInModal").style.display = "none";
    } catch (e) { /* No functionality */ }
  };

  private showModal = () => {
    this.isOpen = true;
    this.buttonClick = false;
    const popup = document.getElementById("changeEmailModal");
    const preregField = document.getElementById("capture_socialRegistration_preregEmailAddress") as HTMLInputElement;
    const emailField = document.getElementById("capture_socialRegistration_email") as HTMLInputElement;
    popup.style.display = "block";
    document.getElementById("capture_socialRegistration_form_item_preregEmailAddress").style.display = "block";
    document.getElementById("capture_socialRegistration_form_item_emailAddress").style.display = "none";
    if (emailField.value) {
      preregField.value = emailField.value;
    }
  };

  private initEmailChangePopup = () => {
    const closeButton = document.getElementById("changeEmailClose");
    const changeEmailConfirm = document.getElementById("changeEmailConfirm");
    const changeEmailPasswordBack = document.getElementById("changeEmailPasswordBack");
    const preregEmailAddressField = document.getElementById("capture_socialRegistration_preregEmailAddress") as HTMLInputElement;
    const emailAddressField = document.getElementById("capture_socialRegistration_emailAddress") as HTMLInputElement;

    if (closeButton) {
      closeButton.addEventListener("click", this.hideModal);
    }
    if (changeEmailConfirm) {
      document.getElementById("changeEmailConfirm").addEventListener("click", this.startEmailCheck);
    }
    if (changeEmailPasswordBack) {
      changeEmailPasswordBack.addEventListener("click", this.setViewChangeEmail);
    }
    if (preregEmailAddressField) {
      preregEmailAddressField.addEventListener("focusout", this.removeValidating);
    }
    if (emailAddressField) {
      emailAddressField.addEventListener("focusout", this.removeValidating);
    }
  };

  private removeValidating = () => {
    if (document.getElementsByClassName("capture_validating")[0]) {
      document.getElementsByClassName("capture_validating")[0].classList.remove("capture_validating");
    }
  };

  private startEmailCheck = () => {
    this.buttonClick = true;
    const changeEmailField = document.getElementById("capture_socialRegistration_preregEmailAddress") as HTMLInputElement;
    const emailNew = changeEmailField.value;
    const emailOriginal = localStorage.getItem("socialEmail");
    if (emailNew !== emailOriginal) {
      localStorage.setItem("noEmailChange", "false");
    } else {
      localStorage.setItem("noEmailChange", "true");
    }
    window.DigitalIdentityHub.utilities.getCaptureField("socialRegistration", "preregEmailAddress")!.focus();
    window.DigitalIdentityHub.utilities.getCaptureField("socialRegistration", "preregEmailAddress")!.blur();
  };

  // Shows sign in screen in the modal window, prefills username field with email change field value and hides the field
  private setViewSignIn = () => {
    this.currentView = "signIn";
    const checkEmailInput = document.getElementById("capture_socialRegistration_emailAddress") as HTMLInputElement;
    const signIn = document.getElementById(this.signInField) as HTMLInputElement;
    if (signIn && checkEmailInput) {
      signIn.value = checkEmailInput.value;
    }

    try {
      window.DigitalIdentityHub.utilities.getCaptureFormItem("socialRegistration", "emailAddress")!.style.display = "none";
      document.getElementById("checkEmailForm_form").style.display = "none";
      document.getElementById("changeEmailConfirm").style.display = "none";
      document.getElementById("changeEmailClose").style.display = "none";
      document.getElementById("signInModal").style.display = "block";
    } catch (e) { /* No functionality */ }
  };

  // Hides sign in screen in the modal window and shows email change field again
  private setViewChangeEmail = (e = null) => {
    this.currentView = "changeEmail";
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    try {
      const socialRegistrationEmail = (document.getElementById("capture_socialRegistration_email") as HTMLInputElement).value;
      window.DigitalIdentityHub.utilities.getCaptureFormItem("socialRegistration", "preregEmailAddress").style.display = "block";
      document.getElementById("checkEmailForm_form").style.display = "block";
      document.getElementById("changeEmailConfirm").style.display = "block";
      document.getElementById("changeEmailClose").style.display = socialRegistrationEmail ? "block" : "none";
      document.getElementById("signInModal").style.display = "none";
    } catch (err) { /* No functionality */ }
  };

  private disableModalCloseButton = () => {
    document.getElementById("changeEmailClose").style.display = "none";
  };

  private enableModalCloseButton = () => {
    document.getElementById("changeEmailClose").style.display = "block";
  };

  private testPrereg = () => {
    // if unique validation fails on prereg email check, remove field classes to preserve the look
    const preregField = document.getElementById("capture_socialRegistration_form_item_preregEmailAddress");
    preregField.classList.remove("capture_error");
    preregField.classList.remove("capture_validating");
    // if button has been clicked, continue with prereg-flow
    if (this.buttonClick) {
      // set button into loading mode
      document.getElementById("changeEmailConfirm").style.opacity = "0.5";
      document.getElementById("changeEmailConfirm").style.pointerEvents = "none";
      this.showCreatePassword();
    } else {
      console.log("Button not clicked");
    }
  };

  private resetButtonClick = () => {
    this.buttonClick = false;
  };

  private setUpSignInField = () => {
    this.signInFieldSet = true;
    const usernameSocial = document.getElementById("capture_socialRegistration_username");
    const signInEmailAddressSocial = document.getElementById("capture_socialRegistration_signInEmailAddress");

    if (usernameSocial) {
      this.signInField = "capture_socialRegistration_username";
    }
    if (signInEmailAddressSocial) {
      this.signInField = "capture_socialRegistration_signInEmailAddress";
    }
  };

  private isUniqueEmail = () => {
    // new account, continue to registration
    // put the change email field value into the hidden email field and the shown read only email field
    // resets email change field and closes the modal window
    const checkEmailElement = document.getElementById("capture_socialRegistration_emailAddress") as HTMLInputElement;
    const registrationEmailElement = document.getElementById("capture_socialRegistration_email") as HTMLInputElement;
    const emailReadElement = document.getElementById("capture_socialRegistration_emailAddress_readonly") as HTMLInputElement;
    const emailReadElementAlt = document.getElementById("userEmailReadOnly") as HTMLSpanElement;
    const emailVerifiedElement = document.getElementById("capture_socialRegistration_emailVerifiedHidden") as HTMLInputElement;
    const originalEmail = localStorage.getItem("socialEmail");

    const email = checkEmailElement ? checkEmailElement.value : "";
    if (registrationEmailElement) {
      registrationEmailElement.value = email;
    }
    if (emailReadElement) {
      emailReadElement.innerHTML = email;
    }
    if (emailReadElementAlt) {
      emailReadElementAlt.innerText = email;
    }
    if (emailVerifiedElement) {
      emailVerifiedElement.value = email === originalEmail ? new Date().toISOString() : "1900-01-01T00:00:00Z";
    }

    this.authProfileEmail = email;

    this.hideModal();
  };
}

export default SocialLogin;
